/**
 * App-level Supabase client — reads Vite env vars and passes to factory.
 *
 * This is the ONLY place in this app where env vars are read for Supabase.
 * All other modules import `supabase` (or the exported URL, used by the
 * unauthenticated /health probe) from this file.
 */
import { createBrowserClient } from '@pazportal/supabase';

export const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL ?? '';
export const SUPABASE_ANON_KEY: string = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

export const supabase = createBrowserClient(SUPABASE_URL, SUPABASE_ANON_KEY);
